// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"az_qhc","headerTitle":"az_rhc","backButton":"az_shc","backIcon":"az_thc","closeIcon":"az_uhc"};